export default {"src":"/_next/static/media/ic_close_results.2b2ff97f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};